
import { Baseline, BaselineLite, BaselineValueLite, EntityModificationTrace, VisionStep } from '@wizeoo/akm-message-lib';
import { WizConstants } from '../../model/constants';

/**
 * demande de chargement d'un step
 */
export class DataLoadObj {

  public static PENDING: string = 'PENDING'; // demande effectuée, en attente
  public static LOADING: string = 'LOADING'; // chargement en cours
  public static LOADED: string = 'LOADED'; // chargé. En attente des frères et soeurs pour calcul ordonné
  public static COMPLETE: string = 'COMPLETE'; // terminé

  public remoteComputed: boolean = false; // Indique que ce DataLoadObj va charger des lignes déja calculées
  public merged: boolean = false;

  // les times
  public startTime: number;
  public endTime: number;

  public totalLocalTime: number;
  public totalRemoteTime: number;
  public totalComputeTime: number;

  // les métriques de chargement
  public loadedRemoteLines: number = 0;
  public loadedRemoteValues: number = 0;


  /** gestion des messages de suivi */
  public localLoaded: boolean = false;
  public nbLinesLoaded: number = 0;
  public nbValuesLoaded: number = 0;
  public remoteLoaded: boolean = false;

  public uniqueKey: string; // la clé unique locale domain#bu#vision#stepLevel#scen
  public visionStep: VisionStep; // le step
  public scenario: string; // le scenario

  // les baselines stockées en indexDB
  public localBaselines: { [key: string]: Baseline } = {};

  public state: string = DataLoadObj.PENDING; // l'état de chargement de ce pool

  public revisionNumber: number = -1; // dernier numRev local
  public previousRevisionNumber: number = -1; // le numRev local précédent
  public nbLines: number = 0; // nombre de lignes à charger
  public nbValues: number = 0; // nombre de values à charger
  public nbDeleted: number = 0; // nombre d'éléments supprimés

  public remoteRevisionNumber: number = -1; // le numRev remote, retourné lors du count

  // les retours de baselines sur appel remote
  public remoteBaselines: { [key: string]: BaselineLite } = {};
  // les valeurs de BLVs sur appel remote
  public remoteBaselineValues: BaselineValueLite[] = [];

  /** Baselines supprimées key = trace */
  public deletedBaselines: Map<string, EntityModificationTrace> = null;
  /** BLVs supprimées key = trace */
  public deletedBaselineValues: Map<string, EntityModificationTrace[]> = null;

  /**
   * constructeur
   * @param uniqueKey la clé unique locale domain#bu#vision#stepLevel#scen
   * @param vision vision cible
   * @param visionStep step cible
   * @param scenario cible (MAIN par défaut)
   */
  constructor(uniqueKey: string, visionStep: VisionStep, scenario: string = WizConstants.BASE_SCENARIO) {
    this.uniqueKey = uniqueKey;
    this.visionStep = visionStep;
    this.scenario = scenario;
  }

  // map des baselines modifiées key = Baseline, la Bl porte l'opération
  public toPersistBaseline: Map<string, Baseline> = new Map();
  // map des baselines modifiées key = Baseline, la Bl porte l'opération
  public toDieBaseline: Map<string, Baseline> = new Map();

}
